module.exports = __webpack_public_path__ + "img/ul.cb63abb7.svg";